import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import useCurrentApplication from 'hooks/useCurrentApplication';
import { formTitle } from 'helpers/forms';
import { FormRoutes } from 'helpers/routes';
import FontAwesomeIcon from 'components/elements/FontAwesomeIcon';
import SectionWrapper from 'components/layout/SectionWrapper';
import VerificationHeader from 'components/layout/VerificationHeader';
import { HistoryBackButton } from 'components/elements/BackButton';

import { getProgramTypeFromApplicationType } from 'utils/enums';
import { FormButton } from './VerificationDetail.styles';

const VerificationDetail = () => {
  const { appData, isReviewer } = useCurrentApplication();
  const { pathname } = useLocation();

  const formButtons = React.useMemo(
    () => [
      {
        id: FormRoutes.prq,
        icon: 'fa-tasks',
        label: formTitle.prq,
        show: appData.requestedAt,
        submited: isReviewer
          ? appData.prqSrSubmittedAt
          : appData.prqSubmittedAt,
      },
      {
        id: FormRoutes.meetingRounds,
        icon: 'fa-calendar-check-o',
        label: formTitle.meetingRounds,
        show:
          appData.prqSubmittedAt
          && getProgramTypeFromApplicationType(appData.applicationType)
            !== 'Fellowship'
          && appData.applicationType !== 'BurnCenterFocusReview',
        submited: isReviewer
          ? appData.meetingsAndRoundsSrSubmittedAt
          : appData.meetingsAndRoundsSubmittedAt,
      },
      {
        id: FormRoutes.keyFindings,
        icon: 'fa-file-text',
        label: formTitle.keyFindings,
        show:
          isReviewer
          && appData.prqSubmittedAt
          && appData.applicationType !== 'BurnCenterFocusReview',
        submited: appData.keyFindingsSubmittedAt,
      },
      {
        id: FormRoutes.finalReport,
        icon: 'fa-check-square-o',
        label: formTitle.siteReport,
        show:
          isReviewer
          && appData.applicationType !== 'BurnCenterFocusReview'
          && appData.prqSubmittedAt,
      },
    ],
    [appData, isReviewer],
  );

  return (
    <SectionWrapper>
      <VerificationHeader
        burnCenterName={appData.bcqpBurnCenterName}
        applicationType={appData.applicationType}
        applicationPopulation={appData.applicationPopulation}
        state={appData.state}
        status={appData.status}
        requestedAt={appData.requestedAt}
        siteVisitAt={appData.siteVisitAt}
        expiredAt={appData.expiredAt}
        isSample={appData.isSample || false}
      />
      <div>
        <HistoryBackButton />
        <div className="mt-4">
          {formButtons.map(
            ({
              id, icon, label, show, submited,
            }) => !!show && (
            <Link to={`../${id}`} key={id} state={{ backTo: pathname }}>
              <FormButton active={!submited}>
                <FontAwesomeIcon className={icon} />
                <div>{label}</div>
              </FormButton>
            </Link>
            ),
          )}
        </div>
      </div>
    </SectionWrapper>
  );
};

export default VerificationDetail;
